import React, { Fragment } from 'react'
import { BreadcrumbItem } from './BreadcrumbItem'
import type { RequiredCategoryBreadcrumbsProps } from './Breadcrumbs'

export const BreadcrumbsPLP = (
    props: RequiredCategoryBreadcrumbsProps
): JSX.Element => {
    const { category, rootText, urlSuffix, urlPrefix } = props
    const sortedBreadcrumbs = category.breadcrumbs?.sort((a, b) =>
        a?.category_level! > b?.category_level! ? 1 : -1
    )

    return (
        <div className="breadcrumbs">
            <BreadcrumbItem url="/" title={rootText} />
            {sortedBreadcrumbs &&
                sortedBreadcrumbs.length &&
                sortedBreadcrumbs.map(
                    (
                        { category_url_key, category_url_path, category_name },
                        key
                    ) => (
                        <Fragment key={`item-${key}`}>
                            {props.separator}

                            <BreadcrumbItem
                                key={`item-${key}`}
                                url={`${urlPrefix}/${
                                    category_url_path
                                        ? category_url_path
                                        : category_url_key
                                }${urlSuffix}`}
                                title={category_name}
                            />
                        </Fragment>
                    )
                )}
            {props.separator}
            <BreadcrumbItem title={category.name} active />
        </div>
    )
}
